import { action, setProperties } from '@ember/object';
import Route from '@ember/routing/route';
import type DestinationSettingsHotelsEditController from 'lumen/controllers/destination/settings/hotels/edit';

type Model = {
  isLoading?: boolean;
  searchTerm: string | null;
  sortBy: string | null;
  sortOrder: string | null;
  totalPages: number;
  totalResults: number;
  totalResultsUnlocked: number;
  userId: string | null;
  userhotelrelationships: unknown;
};

type Params = {
  searchTerm: string | null;
  sortBy: string | null;
  sortOrder: string | null;
  userId: string | null;
};

/**
 * Logic to fill up model is done in the <Settings::HotelAccess::Forms::FormUserEdit> component
 */
export default class DestinationSettingsHotelsEditRoute extends Route {
  queryParams = {
    searchTerm: {
      refreshModel: true,
    },
    sortBy: {
      refreshModel: true,
    },
    sortOrder: {
      refreshModel: true,
    },
    userId: {
      refreshModel: true,
    },
  };

  model(params: Params): Model {
    const { searchTerm, sortBy, sortOrder, userId } = params;

    const existingModel = this.modelFor('destination.settings.hotels.edit') as
      | Model
      | undefined;
    let model: Model;

    if (existingModel === undefined) {
      model = {
        isLoading: true,
        searchTerm,
        sortBy,
        sortOrder,
        totalPages: 0,
        totalResults: 0,
        totalResultsUnlocked: 0,
        userId,
        userhotelrelationships: [],
      };
    } else {
      model = existingModel;

      setProperties(model, {
        isLoading: true,
        searchTerm,
        sortBy,
        sortOrder,
        userId,
      });
    }

    return model;
  }

  resetController(
    controller: DestinationSettingsHotelsEditController,
    isExiting?: boolean,
  ): void {
    if (isExiting) {
      // isExiting would be false if only the route's model was changing
      setProperties(controller, {
        searchTerm: null,
        sortBy: null,
        sortOrder: null,
      });
    }
  }

  @action doRefresh(): void {
    this.refresh();
  }
}
